import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';

import withSize from './components/WithSize/WithSize';
import HeaderWrapper from './components/Header/HeaderWrapper';
import FilterWrapper from './components/Filter/FilterWrapper';
import AreaWrapper from './components/Areas/AreasWrapper/AreasWrapper';
import AreasEDCMapWrapper from './components/Areas/AreasWrapper/AreasEDCMapWrapper';
import FavoritesWrapper from './components/Favorites/FavoritesWrapper';
import PropertyWrapper from './components/Properties/PropertyWrapper/PropertyWrapper';
import Footer from './components/Footer';
import LOHeaderWrapper from './components/LocationOneHeader/LOHeaderWrapper';
import LocationOneFooter from './components/LocationOneFooter/LocationOneFooter';
import WorkforceModal from './components/List/WorkforceModal';
import WorkforceReportsModal from './components/WorkforceReportsModal/WorkforceReportsModal';

import './MapViewer.css';
import './components/List/List.css';
import './CustomPropertyDetailStyles.css';


const classes = process.env.REACT_APP_NARROW ? 'viewer narrow' : 'viewer';
export const MapViewerComponent = ({
  activeOnLoad,
  filterDisplay,
  isMobile,
  location: { search },
  organizationId,
  defaultOrganizationId,
  workforce,
}) => {
  const isDefaultOrg = organizationId === defaultOrganizationId;

  return (
    <div className={`${classes} viewport--${isMobile ? 'mobile' : 'desktop'}`} id={`org${organizationId}`}>
      { isDefaultOrg && <LOHeaderWrapper /> }
      { !isDefaultOrg && <HeaderWrapper /> }
      { filterDisplay && !isMobile && <FilterWrapper filterDisplay={filterDisplay} /> }
      { workforce && <WorkforceModal /> }
      <WorkforceReportsModal />
      <Switch>
        <Route path="/areas/:layer?/:id?/:subTab?" component={AreaWrapper} />
        <Route path="/areas-edc-map/:layer?/:id?/:subTab?" component={AreasEDCMapWrapper} />
        <Route path="/favorites" component={FavoritesWrapper} />
        <Route path="/:propertyType" component={PropertyWrapper} />
        <Redirect
          from="/" to={{
            pathname: `/${activeOnLoad}`,
            search,
          }}
        />
      </Switch>
      { isDefaultOrg && <LocationOneFooter /> }
      { !isDefaultOrg && <Footer copyrightYear="2025" /> }
    </div>
  );
};

MapViewerComponent.propTypes = {
  activeOnLoad: PropTypes.string,
  filterDisplay: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
  organizationId: PropTypes.string,
  defaultOrganizationId: PropTypes.string,
  workforce: PropTypes.bool,
};

const mapStateToProps = ({ filterDisplay, viewer: { activeOnLoad }, workforce }) => {
  return ({
    activeOnLoad,
    filterDisplay,
    workforce,
  });
};

export default withRouter(connect(mapStateToProps)(withSize(MapViewerComponent)));



// WEBPACK FOOTER //
// ./src/MapViewer.js